/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

(function() {

  // ── Auto-open drawer after Add to Cart ──────────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-submit]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;

    var observer = new MutationObserver(function() {
      if (btn.classList.contains('ajax-cart__toggle')) {
        observer.disconnect();
        btn.click();
      }
    });
    observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
  });

  // ── Collapsible cart note toggle ─────────────────────────────────────────
  function initNoteToggle() {
    var noteContainer = document.querySelector('[data-cart-note-container]');
    if (!noteContainer) return;
    if (noteContainer.previousElementSibling && noteContainer.previousElementSibling.classList.contains('cart-drawer__note-toggle')) return;

    var toggle = document.createElement('a');
    toggle.href = '#';
    toggle.className = 'cart-drawer__note-toggle';
    toggle.textContent = '+ Add a note';
    noteContainer.style.display = 'none';
    noteContainer.parentNode.insertBefore(toggle, noteContainer);

    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      var isOpen = noteContainer.style.display !== 'none';
      noteContainer.style.display = isOpen ? 'none' : 'block';
      toggle.textContent = isOpen ? '+ Add a note' : '- Remove note';
    });
  }

  // ── Watch drawer ─────────────────────────────────────────────────────────
  var cartDrawer = document.querySelector('[data-section-type="cart-drawer"]');
  if (cartDrawer) {
    var ariaObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'aria-hidden' && cartDrawer.getAttribute('aria-hidden') === 'false') {
          setTimeout(initNoteToggle, 50);
        }
      });
    });
    ariaObserver.observe(cartDrawer, { attributes: true });

    var domObserver = new MutationObserver(function() {
      initNoteToggle();
    });
    domObserver.observe(cartDrawer, { childList: true, subtree: true });
  }

})();